import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/shared/lib/queryKeys";
import { categoryService } from "@/entities/stock/api/categoryService";
import { MAX_FETCH_ALL_SIZE } from "@/shared/config/pagination";

interface UseCategoriesOptions {
    /** Ver useSuppliers: o tamanho entra na key, cada um tem seu cache. */
    size?: number;
    enabled?: boolean;
}

export function useCategories({ size = MAX_FETCH_ALL_SIZE, enabled = true }: UseCategoriesOptions = {}) {
    const { data, isFetching, refetch } = useQuery({
        queryKey: queryKeys.categories.list(size),
        enabled,
        queryFn: () => categoryService.getAll({ page: 1, size }),
        staleTime: 30 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });

    return {
        categories: data?.content ?? [],
        loadingCategories: isFetching,
        refetchCategories: refetch,
    };
}
